"use client";
import React, { useEffect, useMemo } from "react";
import "~/styles/resources.css";
import useEventsStore from "~/stores/events-store";
import { Button } from "~/components/ui/button";
import * as Accordion from "@radix-ui/react-accordion";
import { PlusIcon, MinusIcon } from "@radix-ui/react-icons";
import { Checkbox } from "components/ui/checkbox";
import { Label } from "components/ui/label";
import { SearchBar } from "../search-bar";

export const EventsFilters = () => {
  const sortingOptions = useEventsStore((state) => state.sortingOptions);
  const sortingOption = useEventsStore((state) => state.sortingOption);
  const setSortingOption = useEventsStore((state) => state.setSortingOption);

  const typeFilterOptions = useEventsStore((state) => state.typeFilterOptions);
  const toggleFilterItem = useEventsStore((state) => state.toggleFilterItem);
  const activeFilters = useEventsStore((state) => state.filters);

  return (
    <div className="">
      <div className="flex items-end justify-between">
        <h5 className="font-h5">Refine results</h5>
        <Button
          className={`h-fit self-end rounded-full p-1 hover:bg-[#ffffff7A] ${
            activeFilters.type.length > 0
              ? "border border-black font-medium"
              : ""
          }`}
          variant="ghost"
          onClick={() => {
            useEventsStore.getState().resetFilters();
            const url = new URL(window?.location?.href);
            url.search = "";
            window?.history?.replaceState(null, "", url.toString());
            window?.location?.reload();
          }}
        >
          clear all
        </Button>
      </div>
      <p className="font-p-sm pt-3">
        Filter and select your search with the following options:
      </p>
      <div className="py-3">
        <Accordion.Root
          type="multiple"
          defaultValue={["types", "sort"]}
          className=""
        >
          <Accordion.Item value="types">
            <Accordion.Header className="flex justify-between border-b border-b-slate-700 py-3">
              <Accordion.Trigger className="flex w-full items-center justify-between gap-3 pr-2 transition-transform duration-200 hover:text-black">
                <h6 className="font-h6 uppercase">Types</h6>
                <PlusIcon className="plus-icon h-4 w-4 shrink-0" />
                <MinusIcon className="minus-icon h-4 w-4 shrink-0" />
              </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Content className="flex flex-col gap-2 py-3">
              {typeFilterOptions.map((type, i) => (
                <div className="flex items-center gap-3 px-2 py-2" key={i}>
                  <Checkbox
                    id={`type-${i}`}
                    checked={activeFilters.type.includes(type)}
                    onCheckedChange={() => toggleFilterItem("type", type)}
                  />
                  <Label
                    htmlFor={`type-${i}`}
                    className="font-p cursor-pointer"
                  >
                    {type}
                  </Label>
                </div>
              ))}
            </Accordion.Content>
          </Accordion.Item>
          <Accordion.Item value="sort">
            <Accordion.Header className="flex justify-between border-b border-b-slate-700 py-3">
              <Accordion.Trigger className="flex w-full items-center justify-between gap-3 pr-2 transition-transform duration-200 hover:text-black">
                <h6 className="font-h6 uppercase">SORT BY</h6>
                <PlusIcon className="plus-icon h-4 w-4 shrink-0" />
                <MinusIcon className="minus-icon h-4 w-4 shrink-0" />
              </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Content className="flex flex-col gap-2 py-3">
              {sortingOptions.map((sorting, i) => (
                <div className="flex items-center gap-3 px-2 py-2" key={i}>
                  <Checkbox
                    id={`sorting-${i}`}
                    checked={sortingOption === sorting}
                    onCheckedChange={() => setSortingOption(sorting)}
                  />
                  <Label
                    htmlFor={`sorting-${i}`}
                    className="font-p cursor-pointer"
                  >
                    {sorting}
                  </Label>
                </div>
              ))}
            </Accordion.Content>
          </Accordion.Item>
        </Accordion.Root>
      </div>
    </div>
  );
};
